module.exports = __webpack_public_path__ + "img/arya-green.6edc43b6.png";